import styled from 'styled-components';
import { MAX_MD, MAX_SM, MAX_XS, MIN_MD, MIN_SM } from '@silverrailtech/srtlibrary';

export const ContentWrapper = styled.div`
	max-width: 1170px;
	margin: auto;
`;

export const TitleStyled = styled.h1`
	font-weight: 600;
	font-size: 36px;
	line-height: 46px;
	margin-block: unset;
	margin-bottom: 16px;
	margin-top: 24px;

	color: #194245;

	span {
		color: #00c575;
	}

	@media screen and (max-width: ${MAX_SM}) {
		padding: 0 16px;
		font-size: 28px;
		line-height: 35px;
	}

	@media screen and (max-width: ${MAX_XS}) {
		font-size: 24px;
		line-height: 29px;
	}
`;

export const MaintenanceContent = styled.div`
	padding: 16px;
	border-radius: 4px;
	background: #ffffff;
	box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);

	@media screen and (min-width: ${MAX_MD}) {
		position: relative;
	}

	@media screen and (max-width: ${MAX_XS}) {
		display: flex;
		flex-direction: column;
		justify-content: space-between;

		min-height: calc(100vh - 218px);
	}

	.text-wrapper {
		z-index: 1;
		@media screen and (min-width: ${MAX_MD}) {
			position: absolute;
			top: 16px;
			left: 16px;
		}

		p {
			font-size: 12px;
			font-weight: 300;
			color: #323232;
			@media screen and (max-width: ${MAX_SM}) {
				font-size: 14px;
				line-height: 21px;
			}
			@media screen and (max-width: ${MAX_XS}) {
				font-size: 17px;
				line-height: 25px;
			}
		}
	}

	.icon-wrapper {
		position: relative;
		height: 200px;
		overflow: hidden;
		&.app-error {
			@media screen and (min-width: ${MIN_SM}) and (max-width: ${MAX_SM}) {
				height: 300px;
			}
		}

		img,
		span {
			width: 1138px;
			height: 200px;
		}

		span {
			position: absolute;
			bottom: 0;
			right: 16px;

			@media screen and (max-width: ${MAX_XS}) {
				right: 0;
			}
		}
	}
`;

export const ButtonStyled = styled.div`
	margin: 32px auto;

	@media screen and (min-width: ${MIN_SM}) {
		max-width: 345px;
	}

	@media screen and (min-width: ${MIN_MD}) {
		max-width: 280px;
		margin: 0;
		margin-top: 24px;
	}
`;
